// extracted by mini-css-extract-plugin
export default {"container":"ResultItem_container__tDNWh","add":"ResultItem_add__ihJ4a","addText":"ResultItem_addText__FnSFF"};